import { getWindow } from 'ts/window/Window';

export function loadFonts() {
  const fontBaseURL = getWindow().fontBaseURL; // This is set in the login.ejs!
  return `@font-face {
    font-family: 'Gordita';
    src: url('${fontBaseURL}gorditaregular-webfont.eot');
    src: url('${fontBaseURL}gorditaregular-webfont.eot?#iefix') format('embedded-opentype'),
      url('${fontBaseURL}gorditaregular-webfont.woff') format('woff'),
      url('${fontBaseURL}gorditaregular-webfont.ttf') format('truetype'),
      url('${fontBaseURL}gorditaregular-webfont.svg#gorditaregular-webfont') format('svg');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'Gordita';
    src: url('${fontBaseURL}gorditamedium-webfont.eot');
    src: url('${fontBaseURL}gorditamedium-webfont.eot?#iefix') format('embedded-opentype'),
      url('${fontBaseURL}gorditamedium-webfont.woff') format('woff'),
      url('${fontBaseURL}gorditamedium-webfont.ttf') format('truetype'),
      url('${fontBaseURL}gorditamedium-webfont.svg#gorditaemgular-webfont') format('svg');
    font-weight: 500;
    font-style: normal;
  }

  @font-face {
    font-family: 'Gordita';
    src: url('${fontBaseURL}gorditabold-webfont.eot');
    src: url('${fontBaseURL}gorditabold-webfont.eot?#iefix') format('embedded-opentype'),
      url('${fontBaseURL}gorditabold-webfont.woff') format('woff'),
      url('${fontBaseURL}gorditabold-webfont.ttf') format('truetype'),
      url('${fontBaseURL}gorditabold-webfont.svg#gorditaegublar-webfont') format('svg');
    font-weight: bold;
    font-style: normal;
  }`;
}